import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import { toggleGlobalSearchBarModal } from "modules/Services";
import { WithConfigurationsAndPreferences } from "Utils/ConfigurationUtils/hoc";
import { generateConfigurationQueryVariablesV2 } from "Utils/ConfigurationUtils/Utils";
import GlobalSearchBarV2 from "./GlobalSearchBarV2";
import GlobalSearchBarV3 from "./GlobalSearchBarV3";
import GlobalSearchBarSkeleton from "./GlobalSearchBarSkeleton";
import { getIsGlobalSearchJumpToV2Enabled } from "./Utils";

const GlobalSearchBarRenderer = ({
  isData,
  isLoading,
  showSearchBar,
  toggleGlobalSearchBarModal,
  ...rest
}) => {
  if (!showSearchBar) {
    return null;
  }

  if (isLoading && !isData) {
    return <GlobalSearchBarSkeleton onClose={toggleGlobalSearchBarModal} />;
  }

  return getIsGlobalSearchJumpToV2Enabled() ? (
    <GlobalSearchBarV3 {...rest} />
  ) : (
    <GlobalSearchBarV2 {...rest} />
  );
};

const mapStateToProps = state => {
  const userInfo = getUserInfo();
  return {
    organizationId: _.get(userInfo, "org_id"),
    showSearchBar: _.get(
      state,
      "app_services.globalSearchBar.showSearchBar",
      false
    ),
    isData: true,
    isLoading: false,
  };
};

export default compose(
  connect(mapStateToProps, { toggleGlobalSearchBarModal }),
  WithConfigurationsAndPreferences({
    skip: ({ organizationId, showSearchBar }) =>
      !organizationId || !showSearchBar,
    options: ({ organizationId }) => ({
      fetchPolicy: "cache-and-network",
      variables: generateConfigurationQueryVariablesV2({
        src: "ORGANIZATION_LEVEL",
        organizationId,
        modules: ["GLOBAL_SEARCH"],
      }),
    }),
    getConfigurationKeys: () => ["ORGANIZATION"],
  })
)(GlobalSearchBarRenderer);
